// Authenticated file download helper (per Mudassir's Jun-17 doc): files must be
// fetched through the backend download APIs (with the auth token) rather than
// opened from stored static paths, so storage can change without breaking FE.
import axiosInstance from "api/axiosInstance";

export async function downloadFile(url, fileName) {
  const response = await axiosInstance.get(url, { responseType: "blob" });
  const blobUrl = window.URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = fileName || "document";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
}

export default downloadFile;
